import { useEffect, useRef } from 'react';
import { useSocket } from './useSocket';

export const useSocketEvent = <T = any>(
  event: string,
  handler: (data: T) => void,
  enabled = true
) => {
  const { on, off } = useSocket();
  const handlerRef = useRef(handler);

  // Keep latest handler without resubscribing
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!enabled) return;

    const wrappedHandler = (data: T) => {
      handlerRef.current(data);
    };

    on(event, wrappedHandler);

    return () => {
      off(event, wrappedHandler);
    };
  }, [event, enabled, on, off]);
};
